<template>
  <div class="filesystem-page">
    <div class="filesystem-shell">
      <div class="filesystem-nav">
        <button class="admin-back-button" type="button" @click="goToAdminArea">
          <i class="fa-solid fa-arrow-left"></i>
          Area amministratore
        </button>
      </div>
      <FileExplorer
        scope="global"
        title="Gestione file MyStudio"
        title-icon="fa-solid fa-folder-tree"
        description="Vista tecnica completa delle cartelle disponibili per il superadmin MyStudio."
        root-label="Tutti gli studi"
        :labels="adminFileSystemLabels"
        permission-error-message="Non hai i permessi per visualizzare i file di tutti gli studi."
      />
    </div>
  </div>
</template>

<script>
import FileExplorer from "@/components/FileExplorer.vue";

const ADMIN_FILESYSTEM_LABELS = {
  Files: "File dello studio",
  "File Convertiti": "File Elaborati",
  "File convertiti": "File Elaborati",
  clienti: "Libreria Bilanci Analitici",
  Clienti: "Libreria Bilanci Analitici",
  utenti: "Utenze dello studio",
  Utenti: "Utenze dello studio",
};

export default {
  name: "FileSystem",
  components: { FileExplorer },
  data() {
    return {
      adminFileSystemLabels: ADMIN_FILESYSTEM_LABELS,
    };
  },
  methods: {
    goToAdminArea() {
      this.$router.push("/home/area-amministratore");
    },
  },
};
</script>

<style scoped>
.filesystem-page {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.filesystem-shell {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.filesystem-nav {
  width: calc(100% - 40px);
  max-width: 1220px;
  margin: 24px 20px 0;
  display: flex;
  justify-content: flex-start;
}

.admin-back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  margin: 0;
  border: 1px solid #c7d0df;
  border-radius: 6px;
  padding: 0 14px;
  background: #ffffff;
  color: #26364d;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(38, 54, 77, 0.08);
}

.admin-back-button:hover {
  background: #eef3fa;
  border-color: #aebad0;
}
</style>
